(function(){
var el=document.getElementById('ebStartData');
if(!el) return;
var D=JSON.parse(el.textContent);
var AF_ID=D.afId, AF_URL=D.afUrl, BOEKEN=D.boeken;
var MINIS=(D.minis&&D.minis.length)?D.minis:[];
var MINI_LABEL='<span class="mini-badge">'+D.miniLabel+'</span>';
var gekozenId=null, gekozenNaam=null;

function cover(b,opts){
  opts=opts||{};
  return '<div class="cover" style="background:var(--cream)">'+
    (b.img ? '<img src="'+b.img+'" alt="Cover van het '+b.naam+'" loading="lazy" width="600" height="800">' : '')+
    (opts.mini?MINI_LABEL:'')+
    (opts.check?'<span class="check">✓</span>':'')+
  '</div>';
}

/* ---------- cadeaukiezer ---------- */
var grid=document.getElementById('miniGrid');
if(grid){
  var KIES = MINIS.length ? MINIS : BOEKEN;
  grid.innerHTML=KIES.map(function(b){
    return '<button class="mini" type="button" aria-pressed="false" data-id="'+(b.id||'')+'" data-naam="'+b.naam+'" aria-label="Kies mini '+b.naam+' als cadeau">'+
      cover(b,{mini:true,check:true})+
      '<span class="mini-foot"><span>'+b.naam+'</span><span class="free">Gratis</span></span></button>';
  }).join('');

  var pickTxt=document.getElementById('pickTxt');
  var pickState=document.getElementById('pickState');
  var buybarSub=document.getElementById('buybarSub');
  var stackMini=document.getElementById('stackMini');

  grid.addEventListener('click',function(e){
    var btn=e.target.closest('.mini'); if(!btn) return;
    grid.querySelectorAll('.mini').forEach(function(m){ m.setAttribute('aria-pressed','false'); });
    btn.setAttribute('aria-pressed','true');
    gekozenId=parseInt(btn.dataset.id,10)||null;
    gekozenNaam=btn.dataset.naam;
    if(pickTxt)   pickTxt.innerHTML='<span class="jouw">Jouw cadeau</span><b>Mini '+gekozenNaam+'</b> gaat gratis mee bij je bestelling.';
    if(pickState) pickState.classList.add('gekozen');
    if(buybarSub) buybarSub.textContent='Mini '+gekozenNaam+' gaat gratis mee';
    if(stackMini){
      stackMini.classList.add('is-gekozen');
      stackMini.querySelector('span').textContent='Mini '+gekozenNaam;
    }
  });
}

/* ---------- collectie ---------- */
var bg=document.getElementById('bookGrid');
if(bg){
  bg.innerHTML=BOEKEN.map(function(b){
    return '<a class="book" href="'+b.url+'">'+cover(b)+
      '<span class="book-foot"><span class="n">'+b.naam+'</span><span class="p">'+b.prijs+'</span></span></a>';
  }).join('');
}

/* ---------- vaste koopbalk ---------- */
var bar=document.getElementById('buybar'), barSpace=document.getElementById('buybarSpace');
var bundels=document.getElementById('bundels'), hero=document.querySelector('.hero');
var foot=document.querySelector('.foot');
function inBeeld(el){ if(!el) return false; var r=el.getBoundingClientRect(); return r.top<window.innerHeight && r.bottom>0; }
function toggleBar(){
  if(!bar||!hero) return;
  // op mobiel vult de video het scherm, dus daar verschijnt de balk eerder:
  // de bezoeker mag nooit zonder zichtbare koopknop zitten
  var drempel = window.innerWidth < 860 ? 300 : hero.offsetHeight+80;
  var toon = window.scrollY > drempel && !inBeeld(bundels) && !inBeeld(foot);
  bar.classList.toggle('show',toon);
  if(barSpace) barSpace.classList.toggle('on',toon);
}
window.addEventListener('scroll',toggleBar,{passive:true});
window.addEventListener('resize',toggleBar);
toggleBar();

/* ---------- reveal ---------- */
if('IntersectionObserver' in window){
  var io=new IntersectionObserver(function(en){
    en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('in'); io.unobserve(x.target); } });
  },{threshold:.1});
  document.querySelectorAll('.rev').forEach(function(el){ io.observe(el); });
} else {
  document.querySelectorAll('.rev').forEach(function(el){ el.classList.add('in'); });
}

/* ---------- productvideo-placeholder ---------- */
var pv=document.querySelector('.flag-visual video');
if(pv) pv.addEventListener('playing',function(){
  var ph=document.querySelector('.flag-visual .ph'); if(ph) ph.style.display='none';
});


document.addEventListener('click',function(e){
  var knop=e.target.closest('.js-koop'); if(!knop) return;
  if(!AF_ID){ window.location.href=AF_URL; return; }
  var orig=knop.innerHTML; knop.disabled=true; knop.textContent='Bezig\u2026';
  var items=[{id:AF_ID,quantity:1}];
  if(gekozenId){ items.push({id:gekozenId,quantity:1}); }
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:items})})
  .then(function(r){ if(!r.ok) throw 0; return r.json(); })
  .then(function(){ window.location.href='/cart'; })
  .catch(function(){ knop.disabled=false; knop.innerHTML=orig; window.location.href=AF_URL; });
});
/* video's op iOS actief starten */
document.querySelectorAll('video[autoplay]').forEach(function(v){
  v.muted=true; v.setAttribute('muted','');
  v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
  var start=function(){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); };
  start();
  v.addEventListener('loadeddata',start,{once:true});
  document.addEventListener('touchstart',start,{once:true});
});
})();